import { render, staticRenderFns } from "./addModifierGroup.vue?vue&type=template&id=d236ea0a&scoped=true&"
import script from "./addModifierGroup.vue?vue&type=script&lang=js&"
export * from "./addModifierGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d236ea0a",
  null
  
)

export default component.exports